var map = {
	"./cota_58_norte.json": "ddc6",
	"./cota_58_sur.json": "0711",
	"./cota_59_norte.json": "c73d",
	"./cota_59_sur.json": "de85",
	"./cota_60_norte.json": "4711",
	"./cota_60_sur.json": "2dc1",
	"./cota_61_norte.json": "4102",
	"./cota_61_sur.json": "f265",
	"./cota_62_norte.json": "7391",
	"./cota_62_sur.json": "cd4d",
	"./cota_63_norte.json": "6957",
	"./cota_63_sur.json": "433b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f75";